export const AdminRestApiPaths = {
  login: "/admin/login",
  organization: "/admin/organization",
  brand: "/admin/brand",
  user: "/admin/user",
  accountingOAuthConnect: "/admin/accounting/oauth/connect",
  accountingOAuthDisconnect: "/admin/accounting/oauth/disconnect",
  accountingOAuthStatus: "/admin/accounting/oauth/status",
  accountingOAuthActiveSystem: "/admin/accounting/oauth/active-system",
} as const;

export type AdminRestApiPath =
  (typeof AdminRestApiPaths)[keyof typeof AdminRestApiPaths];
